module.exports = __webpack_public_path__ + "img/avatar1.ad927651.png";